/**
 * Environment Configuration
 * 
 * Priority:
 * 1. REACT_APP_API_URL (environment variable) - for production deployments
 * 2. USE_LOCAL_API flag - for local development
 * 3. Default: PRODUCTION (https://rodbot-backend.onrender.com)
 */

// ============================================================
// 🔧 TOGGLE THIS FOR LOCAL DEVELOPMENT
// ============================================================
const USE_LOCAL_API = true;  // Set to true for localhost:8000
// ============================================================

// API URLs
const PRODUCTION_URL = 'https://rodbot-extended.onrender.com';
const LOCAL_URL = 'http://localhost:8000';

// Use environment variable if set, otherwise use flag
const getApiUrl = () => {
  // Check for environment variable first (for production)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Fall back to local flag for development
  return USE_LOCAL_API ? LOCAL_URL : PRODUCTION_URL;
};

export const API_BASE_URL = getApiUrl();

export const ENV = {
  API_URL: API_BASE_URL,
  IS_PRODUCTION: !USE_LOCAL_API,
  IS_LOCAL: USE_LOCAL_API,
};

export default ENV;

